import { useQuery } from 'react-query';
import { fetchBots, fetchCreations } from 'api/bot';
import { useAuthStore } from 'store/auth';
import { generateArray } from 'utils';
import { BotSkeleton } from 'components/skeletons/BotSkeleton';
import Link from 'next/link';
import { Bot, BotCreation } from 'api/bot/types';
import { BotCreationCard } from 'components/lists/cards/BotCreationCard';
import { useEffect } from 'react';
import { reactQuery } from 'lib/reactQuery';
import { Plus } from 'components/icons/Plus';
import { BotCardItem } from 'components/lists/cards/BotCardItem';

const MyCrushesPage = () => {
  const { isLogged } = useAuthStore();

  const { data: myCreations, isLoading: isLoadingCreations } = useQuery('myCreations', fetchCreations, {
    enabled: isLogged
  });

  const { data: myBots, isLoading: isLoadingBots } = useQuery(
    'myBots',
    async () => await fetchBots({ mine: true, authorized: true }),
    { enabled: isLogged }
  );

  useEffect(() => {
    return () => {
      reactQuery.removeQueries('myBots');
      reactQuery.removeQueries('myCreations');
    };
  }, []);

  const createNew = (
    <Link
      prefetch={false}
      className="group relative border-2 border-primary rounded-xl overflow-hidden cursor-pointer p-5 flex flex-col items-center justify-center gap-3 h-[250px] lg:h-[400px]"
      key="create-new"
      href="/create"
    >
      <div className="flex justify-center items-center border border-brand rounded-full p-3 mb-3">
        <Plus className="lg:w-10 lg:h-10 w-6 h-6" />
      </div>
      <p className="text-xl text-center lg:text-2xl text-stone-400 group-hover:text-brand">Create new Krush</p>
    </Link>
  );

  const skeleton = generateArray(8).map((i) => <BotSkeleton key={i} />);

  return (
    <div className="container">
      <div className="flex flex-col gap-20 py-10">
        <div>
          <h1 className="title mb-10 text-center">My Krushes</h1>
          <div className="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
            {isLoadingBots
              ? skeleton
              : [createNew, ...(myBots?.data?.map((bot: Bot) => <BotCardItem key={bot.id} data={bot} />) || [])]}
          </div>
        </div>

        <div>
          <h2 className="title mb-10 text-center">Pending Krushes</h2>
          <div className="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
            {isLoadingCreations
              ? skeleton
              : [
                  createNew,
                  ...(myCreations?.map((creation: BotCreation) => (
                    <BotCreationCard key={creation.id} data={creation} />
                  )) || [])
                ]}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MyCrushesPage;
